import TranslateImportForm from "./translate-import-forms";

export default TranslateImportForm;